module.exports = __webpack_public_path__ + "img/header.b837d97.jpg";